<template>
  <div class="page noselect">
    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->

    <v-container grid-list-xl>
      <h2 class="myTitle mt-5 text-center">Meine Favoriten</h2>

      <div v-if="favFoods.length<1 && favDrinks.length<1" class="pt-4 text-center">
        Du hast noch keine Favoriten ausgewählt
      </div>

      <v-layout row wrap v-if="favFoods.length > 0">
        <v-flex xs6 md4 v-for="(food, index) in favFoods" class="pt-2 pb-1 pl-2 pr-2">
          <div class="tile myBoxShadow pointer" @click.passive="gotoFood(food.id)">
            <div class="itemImage withloader">
              <v-avatar color="#888" height="180" width="180">
                <img v-if="hasImage(food)" :src="food.image">
                <img v-else alt="App" src="../assets/placeholder6-opti.png">
              </v-avatar>
            </div>
            <div class="itemName bfont">{{ food.nameToDisplay }}</div>
            <div class="fextras">{{ food.extrasToDisplay | stringList }}</div>
            <div class="deleteIcon" @click.passive.stop="removeFavFood(food.id)">
              <v-icon medium color="accent">mdi-close-circle</v-icon>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="favDrinks.length > 0">
        <v-flex xs6 md4 v-for="(drink, index) in favDrinks" class="pt-2 pb-1 pl-2 pr-2">
          <div class="tile myBoxShadow pointer" @click.passive="gotoDrink(drink.id)">
            <div class="itemImage withloader">
              <v-avatar color="#888" height="180" width="180">
                <img v-if="hasImage(drink)" :src="drink.image">
                <img v-else alt="App" src="../assets/placeholder6-opti.png">
              </v-avatar>
            </div>
            <div class="itemName bfont">{{ drink.nameToDisplay }}</div>
            <div class="fextras">{{ drink.extrasToDisplay | stringList }}</div>
            <div class="deleteIcon" @click.passive.stop="removeFaDrink(drink.id)">
              <v-icon medium color="accent">mdi-close-circle</v-icon>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="last1Orders.length > 0">
        <v-flex xs12 class="pt-10">
          <h3 class="text-center">Letzte Bestellung(en) wiederholen</h3>
        </v-flex>
        <v-flex xs12 md6 v-for="(order, index) in last1Orders" class="pt-2 pb-1 pl-2 pr-2">
          <div class="orderItemsBox myBoxShadow">
            <ItemDetails :order="order" :with-total="false"></ItemDetails>

            <div class="flexJustifyCenter mt-7">
              <v-btn class="btn-df" rounded @click="reOrder(order)">
                <v-icon left medium>
                  mdi-cart-arrow-down
                </v-icon>
                Zum Korb hinzufügen
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div class="spacer-25"></div>
      <div class="spacer-25"></div>
      <div class="text-center">
        <v-btn class="btn-df okBtn text-none" rounded @click.native.passive="gotoSortiment"
               style="width: auto">
          Zu unserem Sortiment
          <v-icon right medium>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
      <div class="spacer-25"></div>

    </v-container>

    <FixBasket></FixBasket>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import {cloneMe} from '../vendor/util';
// import * as qconst from '../vendor/qconstants';
import FixBasket from "../components/FixBasket.vue";
import ItemDetails from "../components/ItemDetails.vue"

export default {
  name: "Favorites",
  components: {FixBasket, ItemDetails},
  computed: {
    favFoods() {
      return store.getters.favFoods;
    },
    favDrinks() {
      return store.getters.favDrinks;
    },
    last1Orders() {
      try {
        let orders = store.getters.lastOrders || [];
        let last = orders.filter(order => order !== null).slice(0, 10);
        // let last = orders.filter(order => order !== null).reverse().slice(0, 10);
        return last
      } catch (e) {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  created() {
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      ebus.$emit('loadUserPreferences');
    },

    hasImage(item) {
      return 'image' in item && item.image.length > 0;
    },

    removeFavFood(favFood) {
      store.commit('removeFavFood', favFood);
      ebus.$emit('saveUserPreferences');
    },

    removeFaDrink(favDrink) {
      store.commit('removeFavDrink', favDrink);
      ebus.$emit('saveUserPreferences');
    },

    // removeFavDrinkAt(index) {
    //     this.drinks.splice(index, 1);
    //     store.commit('replaceFavDrinks', cloneMe(this.drinks));
    //     ebus.$emit('favoritesUpdated');
    //     ebus.$emit('saveUserPreferences');
    // },

    // gotoDrink(itemId) {
    //     this.$router.push({name: 'drinkItem', params: {drinkId: itemId}});
    // },

    gotoFood(itemId) {
      this.$router.push({name: 'Speise', params: {itemId: itemId}});
    },
    gotoDrink(itemId) {
      this.$router.push({name: 'Getraenk', params: {itemId: itemId}});
    },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    reOrder(order) {
      const filteredItems = order.orderData.filter(item => item.type === 'foodOrder' || item.type === 'drinkOrder');
      let any = false;
      for (let itm of filteredItems) {
        any = true;
        store.commit('addItemToCart', {
          item: itm,
          noAvailabiltyChecks: true,
        });
        ebus.$emit('triggerShowAdded');
      }
      if (!any) {
        ebus.$emit('toast', 'Diese Bestellung kann nicht ausgwählt werden');
      }
      // store.commit('addItemsToCart', filteredItems);
    }

  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.orderItemsBox {
  border-radius: $box-border-radius;
  margin: 12px 0;
  padding: 5px 15px 15px 15px;
  background-color: rgba(white, 0.7);
}

/*.v-avatar {*/
/*    max-width: 120px !important;*/
/*    max-height: 120px !important;*/
/*    margin-bottom: 5px;*/
/*}*/

.itemImage {
  padding-bottom: 5px;
  /*    img {*/
  /*        width: 15vw !important;*/
  /*        max-width: 120px !important;*/
  /*        height: auto !important;*/
  /*    }*/

  img {
    width: auto;
  }
}

.itemImage ::v-deep .v-avatar {
  max-width: 35vw;
  max-height: 35vw;
}

.fextras {
  color: $accent;
}

.deleteIcon {
  position: absolute;
  top: 0px;
  right: -5px;
  height: 50px;
  width: 50px;
  /*padding: 5px 0 0 0;*/
}

.tile {
  cursor: pointer;
  text-align: center;
  position: relative;
  //background-color: rgba($color-primary, 0.9);
  background-color: rgba(white, 0.7);
  color: black;
  //@include material-shadow(1);
  border-radius: $box-border-radius;

  &:hover {
    filter: brightness(120%);
  }

  /*border: 1px solid #666;*/
  padding: 15px;
  min-height: 100px;
  height: 100%;
  overflow: hidden;
}

</style>
